import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchBanners } from '~/src/features/domru-tv/packages/store/actions/fetchBanners';
import { TState } from '~/src/store';

import { HeadSection, PageTitle, SPromoBannersSection } from './styled';

const PageHeader = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchBanners());
    }, [dispatch]);

    const {
        banners,
    } = useSelector((state: TState) => ({
        banners: state.tvSubscriptions.banners.payload,
    }));

    return (
        <HeadSection>
            <PageTitle>Все развлечения — в одном Movix</PageTitle>
            <SPromoBannersSection
                banners={banners}
                withEllipsis={false}
                data-test='banners-section'
            />
        </HeadSection>
    );
};

export default PageHeader;
